/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `youtube` - YouTube Shorts
 * `instagram` - Instagram Reels
 * `tiktok` - TikTok
 */
export type PlatformEnum = (typeof PlatformEnum)[keyof typeof PlatformEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformEnum = {
  youtube: "youtube",
  instagram: "instagram",
  tiktok: "tiktok",
} as const;
